import { FormGroup } from '@angular/forms';

export const checkValidation = (form: FormGroup): void => {
  Object.values(form.controls).forEach((control) => {
    if (control.invalid) {
      control.markAsDirty();
      control.updateValueAndValidity({ onlySelf: true });
    }
  });
};

export const trimWhitespace = (form: FormGroup): void => {
  Object.values(form.controls).forEach((control) => {
    if (typeof control?.value === 'string') {
      const trimmedValue = control?.value.trimStart().trimEnd();

      control.setValue(trimmedValue, { emitEvent: false });
    }
  });
};
